import { ApplicationStatus } from "@shared/publicportal/contracts/ApplicationStatus";

interface ApplicationStatusCellProps {
    applicationStatus: ApplicationStatus | null;
}

const ApplicationStatusCell = (props: ApplicationStatusCellProps) => {
    const { applicationStatus } = props;

    function getApplicationStatusColor() {
        const colors = {
            green: "rgb(53, 179, 53)",
            red: "rgb(243, 0, 0)",
            darkRed: "rgb(181, 85, 85)",
            olive: "rgb(154, 193, 0)",
            gray: "rgb(172, 169, 169)",
        };

        let color = "";
        switch (applicationStatus) {
            case ApplicationStatus.Completed:
                color = colors.green;
                break;
            case ApplicationStatus.Invalid:
                color = colors.red;
                break;
            case ApplicationStatus.Refused:
                color = colors.red;
                break;
            case ApplicationStatus.Pending:
                color = colors.darkRed;
                break;
            case ApplicationStatus["Compliance Report"]:
                color = colors.olive;
                break;
            case ApplicationStatus.Archived:
                color = colors.gray;
                break;
            default:
                color = "initial";
                break;
        }

        return color;
    }

    const color = getApplicationStatusColor();
    return (
        <div style={{ color }} className="entityTable__applicationStatusCell">
            {applicationStatus}
        </div>
    );
};

export default ApplicationStatusCell;
